package com.flowyride.core.domain.routing

import com.flowyride.core.domain.model.GeoPoint
import com.flowyride.core.domain.model.Maneuver
import com.flowyride.core.domain.model.SpeedLimitSection

/** What an engine knows about a line drawn elsewhere; indices point into that line. */
data class TrackGuide(
    val maneuvers: List<Maneuver>,
    val speedLimits: List<SpeedLimitSection> = emptyList(),
)

/** Turn-by-turn instructions and speed limits for a line drawn elsewhere (an imported GPX), without changing the line. */
interface TrackGuidance {
    /** @throws RoutingException */
    suspend fun guideAlong(track: List<GeoPoint>): TrackGuide
}
